import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import ExportBlob from '../../../common/export-blob';
import { getCurrentDate } from '../../../helpers/Common';
import { downloadScreener } from '../reducer';

class Export extends React.Component {
  handleExport = () => {
    const { downloadScreener, tab, locale } = this.props;
    const name = I18n.t('common.export.stockScreener.' + tab, {
      date: getCurrentDate(),
    });
    downloadScreener(locale, tab - 1, name);
  };

  render() {
    return <ExportBlob handleExport={this.handleExport} />;
  }
}

const mapStateToProps = state => ({ i18n: state.i18n });

const mapDispatchToProps = {
  downloadScreener,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Export);
